import { Injectable } from '@angular/core';

/**
 * Servicio utilitario para leer y escribir datos en el `localStorage` del
 * navegador, serializando y deserializando los valores en formato JSON.
 */
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  /**
   * Guarda un valor en `localStorage` serializándolo como JSON.
   * @param key - Clave bajo la cual se almacena el dato.
   * @param data - Valor a persistir.
   */
  saveData(key: string, data: any): void {
    localStorage.setItem(key, JSON.stringify(data));
  }

  /**
   * Recupera y deserializa un valor almacenado en `localStorage`.
   * @param key - Clave del dato a recuperar.
   * @returns Valor deserializado o cadena vacía si no existe.
   */
  getData(key: string): any {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : '';
  }

  /**
   * Almacena un valor en `localStorage` serializándolo como JSON.
   * @param key - Clave bajo la cual se almacena el dato.
   * @param data - Valor a persistir.
   */
  setData(key: string, data: any): void {
    localStorage.setItem(key, JSON.stringify(data));
  }

  /**
   * Construye el nombre completo del usuario a partir del correo almacenado.
   * @returns Nombre y apellido en mayúsculas, o cadena vacía si no aplica.
   */
  getFullName(): string {
    let userEmail = this.getData('userEmail');
    if (userEmail && userEmail.includes('.')) {
      const currentUser = userEmail.split('@')[0]
      let [name, lastname] = currentUser.split('.');
      name = name.toUpperCase();
      lastname = lastname.toUpperCase();
      return `${name} ${lastname}`;
    }
    return '';
  }
}
